import { ScoreDataSource, NullScoreDataSource, ReviewScore, OverviewScore } from "../datasource/score";
import { AttemptId, Serializer, QuizId } from "../datasource";

export abstract class ScoreModel<A extends AttemptId, Z extends QuizId> {
	datasource: ScoreDataSource<A, Z>;

	protected constructor(datasource?: ScoreDataSource<A, Z>) {
		this.datasource = datasource ?? new NullScoreDataSource(new Serializer());
	}

	abstract getOverviewScores(): Promise<OverviewScore<A, Z>[]>
	abstract getReviewScores(): Promise<ReviewScore[]>
	abstract getTotalScores(): Promise<ReviewScore>
}

export class NullScoreModel<A extends AttemptId, Z extends QuizId> implements ScoreModel<A, Z> {
	datasource: ScoreDataSource<A, Z>;

	getOverviewScores(): Promise<OverviewScore<A, Z>[]> {
		throw new Error("Method not implemented.");
	}

	getReviewScores(): Promise<ReviewScore[]> {
		throw new Error("Method not implemented.");
	}

	getTotalScores(): Promise<ReviewScore> {
		throw new Error("Method not implemented.");
	}
}

